export default "__VITE_ASSET__cbd14679__"